import { Model } from "./model";

import { PostFile } from "./post-file.model";

export class Post extends Model {
    average_rating: number;
    brand_id: number;
    brand_logo: string
    brand_logo_url: string
    brand_name: string;
    content: string
    country_id: number;
    country_name: string;
    created: string;
    excerpt: string;
    id: number;
    image: string;
    image_url: string;
    language_flag: string;
    language_id: number;
    language_name: string;
    likes: number;
    name: string;
    product_id?: number;
    product_name?: string;
    product_ref?: string;
    feedbacks_enabled: number;
    published: number;
    pinned: number;
    files?: PostFile[];
}


// WEBPACK FOOTER //
// ./src/models/post.model.ts